import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import DatePicker from '../../../../../components/DatePicker';
import 'parsleyjs';

class ProspectusForm extends Component {
    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.updateAddNewProspectusData = this.updateAddNewProspectusData.bind(
            this
        );
    }

    updateAddNewProspectusData(prospectus) {
        let { updateProspectusData } = this.props;
        updateProspectusData(prospectus);
    }

    handleInputChange(event) {
        let { prospectusData, isEditable } = this.props;
        if (isEditable) {
            const target = event.target;
            const value =
                target.type === 'checkbox' ? target.checked : target.value;
            const name = target.name;

            let tmpSelected = _.extend({}, prospectusData);
            tmpSelected[name] = value;
            this.updateAddNewProspectusData(tmpSelected);
        }
    }

    handleDateChange(name, value) {
        let { prospectusData } = this.props;
        let tmpSelected = _.extend({}, prospectusData);
        if (value !== null) {
            tmpSelected[name] = value;
        } else {
            tmpSelected[name] = '';
        }
        this.updateAddNewProspectusData(tmpSelected);
    }

    render() {
        let { prospectusData, isEditable, formRef } = this.props;

        return (
            <form ref={formRef}>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>*Name</label>
                        <input
                            className="form-control"
                            type="text"
                            name="name"
                            value={prospectusData.name}
                            onChange={this.handleInputChange}
                            disabled={!isEditable}
                            data-parsley-required
                            data-parsley-maxlength="200"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-12">
                        <label>*Prospectus Date</label>
                        <div>
                            <DatePicker
                                name="prospectusDate"
                                value={prospectusData.prospectusDate}
                                onChange={this.handleDateChange}
                                disabled={!isEditable}
                                required={true}
                            />
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

ProspectusForm.propTypes = {
    prospectusData: PropTypes.object.isRequired,
    updateProspectusData: PropTypes.func,
    isEditable: PropTypes.func.bool
};

ProspectusForm.defaultProps = {
    isEditable: true
};
export default ProspectusForm;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientDetails/components/ProspectusForm.js